import { useEffect, useState } from "react";

export const useColorChanger = (length: number) => {
	const [spotColor, setSpotColor] = useState(0);

	useEffect(() => {
		const myInterval = setInterval(() => {
			setSpotColor((prev) => {
				if (prev === length) {
					return 0;
				}
				return prev + 1;
			});
		}, 600);
		return () => {
			clearInterval(myInterval);
		};
	}, [length]);

	return spotColor;
};
